import React from 'react'
import FormGroupAtom from '../../@atoms/to_forms/form_group/form_group.atom'
import ButtonDateTimeslotAtom from '../../@atoms/to_forms/button_date_timeslot/button_date_timeslot_atom'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import bestDateData from '../../data/schema/best_dates.json'

const DateSelectionFormComponent = function () {
  return (
    <FormGroupAtom>
      <ButtonDateTimeslotAtom ap_data_arr={bestDateData} />
      <ButtonAtom ap_type="secondary"> Submit </ButtonAtom>
    </FormGroupAtom>
  )
}

export default DateSelectionFormComponent
